<template>
  <section class="why">
    <div class="container">
      <a-typography-title :level="1">
        为什么选择星汉未来InfraPilot?
      </a-typography-title>
      <div class="box_list">
        <div v-for="item in expand.content" :span="24"
             class="item">
          <a-row>
            <a-col :xs="24" :md="4">
              <div class="image" />
            </a-col>
            <a-col :xs="24" :md="4">
              <a-typography-title :level="5">
                {{ item.title }}
              </a-typography-title>
            </a-col>
            <a-col :xs="24" :md="16">
              <a-typography-paragraph>
                {{ item.text }}
              </a-typography-paragraph>
            </a-col>
          </a-row>
        </div>
      </div>
      <!-- <a-space :size="$Store.Public().isGridMatch('>=',$Enum.GridEnum.XL)?'large':'small'">
        <a-button type="link" class="button_n_2"
                  @click="clickToCloud()">
          立刻在线体验
        </a-button> -->
        <!--<a-button type="link" class="button_1"-->
        <!--       @click="$Store.Page().openModal('modalFormCollection', 'deployment')">-->
        <!--  预约私有化部署-->
        <!--</a-button>-->
      <!-- </a-space> -->
    </div>
  </section>
</template>

<script lang="ts" type="text/tsx">
import { DataInterface } from '@interface/public';

export default {
  name: 'product_why',
  data(): DataInterface {
    return {
      expand: {
        content: [
          {
            title: '全场景',
            text: '适用于Web后端服务、音视频、数据处理、物联网等各种场景，无需进行函数化改造、容器和微服务改造，即可低成本部署Serverless平台。'
          },
          {
            title: '故障自愈',
            text: '通过提供故障自愈能力，帮助企业轻松构建无需监管的应用系统，不仅能提升系统稳定性，同时还节省了大量人力。'
          },
          {
            title: '开放中立',
            text: '自动适配阿里云、华为云、AWS等多个常用云平台，并且支持跨云跨地域快速迁移业务数据，打造开放的业务环境。'
          }
        ]
      }
    };
  },
  methods: {
    /**
     * 点击去云平台
     */
    clickToCloud(): void {
      // location.href = $Config.Href.cloud;
      open($Config.Href.cloud);
    }
  }
};
</script>

<style lang="less" rel="stylesheet/less" scoped>
@import '@resource/css/_global.less';

@imagePublic: '@{src_image}page/public/';
@image: '@{src_image}page/productInfraPilot/';
@b: 1px solid @color_15;

.why {
  overflow: hidden;
  position: relative;
  padding: 0 @padding;
  .bg('@{imagePublic}bg_1.jpg');
  background-size: cover;
  
  .container {
    position: relative;
    max-width: @grid_xl;
    padding: @space 0;
    margin: 0 auto;
    text-align: center;
  }
}


h1.ant-typography {
  position: relative;
  margin: 0;
  .font(center, @title, @color_12, @title, true);
}

.box_list {
  margin: @margin 0 0;
  
  .item {
    @w: 80px;
    @h: 60px;
    position: relative;
    width: 100%;
    max-width: 1000px;
    padding: 20px 0;
    margin: 20px auto 0;
    background-color: fade(@color_white, 75);
    border: @b;
    border-radius: 5px;
    
    .loop(@i) when (@i<=3) {
      &:nth-child(@{i}) {
        .image {
          background-position-x: -(-1+@i)*@w;
        }
      }
      .loop(@i+1);
    }
    .loop(1);
    
    &:first-child {
      margin: 0 auto;
    }
    
    &:hover {
      &::before {
        .transform(scale(1.1));
      }
    }
    
    .image {
      width: @w;
      height: @h;
      margin: 0 auto;
      .bg('@{image}why_icon.png', @w*3, @h);
      .transition(transform 1s);
    }
    
    h5.ant-typography {
      margin: 0;
      border-left: @b;
      border-right: @b;
      .font(center, @h, @color_12, @text_big, true);
    }
    
    div.ant-typography {
      padding: 0 50px;
      margin: 0;
      .font(justify, 30px, @color_3, @text);
      .wordBreak();
    }
  }
}

.ant-space {
  margin: @margin 0 0;
}

@media screen and (max-width: -1px+@grid_md) {
  .why {
    .container {
      padding: @space_mo 0;
    }
  }
  
  h1.ant-typography {
    .font(center, @title_mo, @color_12, @title_mo, true);
  }
  
  .box_list {
    .item {
      h5.ant-typography {
        border-left: none;
        border-right: none;
      }
      
      div.ant-typography {
        padding: 0 20px;
      }
    }
  }
}
</style>